import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Status,
  StatusState,
  StatusVariant,
  theme,
} from '@ketch-com/deck'
import { GetConsentStatusResponseBodySubscriptionsItemDTO } from '@ketch-com/figurehead'
import { Box, Typography } from '@mui/material'
import { ChannelCards } from 'pages/insights/auditLog/components/subscriptionsTab/components/TopicItem/components/ChannelAccordion/components/ChannelCards'
import { ChannelConnections } from 'pages/insights/auditLog/components/subscriptionsTab/components/TopicItem/components/ChannelAccordion/components/ChannelConnections'
import { ContactMethod, ContactMethodLabels } from 'pages/insights/auditLog/constants'
import { useState } from 'react'

type ChannelAccordionProps = {
  channel: GetConsentStatusResponseBodySubscriptionsItemDTO
}

export const ChannelAccordion: React.FC<ChannelAccordionProps> = ({ channel }) => {
  const [expanded, setExpanded] = useState(false)
  const isEnabled = !!channel.allowed
  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      sx={{
        borderTop: `1px solid ${theme.palette.Common.Divider}`,
        borderRadius: '0px !important',
        marginTop: '0px !important',
      }}
    >
      <AccordionSummary onExpandIconClick={() => setExpanded(expanded => !expanded)}>
        <Box display="flex" flexDirection="column" gap="4px">
          <Typography variant="label">{ContactMethodLabels[channel.contactMethod as ContactMethod]}</Typography>
          <Box width="fit-content">
            <Status
              icon={isEnabled ? 'OCheck' : 'OCross'}
              label={isEnabled ? 'Enabled' : 'Disabled'}
              status={isEnabled ? StatusState.success : StatusState.error}
              variant={StatusVariant.filled}
            />
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <ChannelCards channel={channel} />
        <ChannelConnections channel={channel} />
      </AccordionDetails>
    </Accordion>
  )
}
